import { useTranslation } from 'react-i18next'

interface OptionalFieldsGridProps {
  gtin: string
  sku: string
  price: string
  category: string
  onGtinChange: (v: string) => void
  onSkuChange: (v: string) => void
  onPriceChange: (v: string) => void
  onCategoryChange: (v: string) => void
  inputClassName: string
}

const LABEL_CLS = 'block text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-1'

export function OptionalFieldsGrid({
  gtin, sku, price, category,
  onGtinChange, onSkuChange, onPriceChange, onCategoryChange,
  inputClassName,
}: OptionalFieldsGridProps) {
  const { t } = useTranslation()
  return (
    <div className="grid grid-cols-2 gap-3">
      <div>
        <label className={LABEL_CLS}>{t('amazonListing.manual.gtin')}</label>
        <input value={gtin} onChange={(e) => onGtinChange(e.target.value)} className={inputClassName} />
      </div>
      <div>
        <label className={LABEL_CLS}>{t('amazonListing.manual.sku')}</label>
        <input value={sku} onChange={(e) => onSkuChange(e.target.value)} className={inputClassName} />
      </div>
      <div>
        <label className={LABEL_CLS}>{t('amazonListing.manual.price')}</label>
        <input value={price} onChange={(e) => onPriceChange(e.target.value)} placeholder="29.99" className={inputClassName} />
      </div>
      <div>
        <label className={LABEL_CLS}>{t('amazonListing.manual.category')}</label>
        <input value={category} onChange={(e) => onCategoryChange(e.target.value)} className={inputClassName} />
      </div>
    </div>
  )
}
